import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableEmployeeTaskDetails } from '../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames;

        return (
            <div>
                <h3 className="pl-2"><u>Daily Employee Task Details</u></h3>
                <div className="row pl-2 pb-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Employee: </b> {searchData.employee === undefined ? "All Employees" : searchData.employee}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th>Card Number</th>
                                <th>Progress</th>
                                <th>Task Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableEmployeeTaskDetails
                                data={data}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}